<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/psychology' }"
        >心理测评</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="left">心理测评</div>
        </div>
        <div class="center">
          对于一个中学生，心理的状态是特别重要的。根据年龄、家庭、环境等因素的变化，心理的状态也会变化。通过焦虑、抑郁、心理健康等维度进行测试，进一步了解自己的心理状态，在老师的帮助和指导下，找到合适的解决方法，让学习无忧，乐观积极向上的发展。注意：心理测评只能提供一个心理学方面的参考，并不能为一个人下终生的论断。
        </div>
        <div class="btn">
          <div
            class="appraisal"
            @click="goTest(item.id)"
            v-for="(item, index) in list"
            :key="index"
          >
            <img :src="item.pic" alt="" />
          </div>
          <div class="appraisal"><img src="./images/test4.png" alt="" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getlista } from "@/api/home";
export default {
  name: "HXtudystatus",
  data() {
    return {
      list: "",
    };
  },

  async mounted() {
    const res = await Getlista(this.$route.query.menuId || "339908117110853");
    this.list = res.data||res.result;
  },

  methods: {
    goTest(ScaleId) {
      this.$router.push({ path: "/psychologyTesting", query: { ScaleId } });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 1050px;
  background-color: #fff;
  margin-top: 10px;
  min-width: 1050px;
  .content {
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    .top {
      margin-bottom: 8px;
      .left {
        font-size: 22px;
        color: #333;
      }
    }
    .center {
      font-size: 16px;
      color: #666;
      margin-bottom: 53px;
    }
    .btn {
      display: flex;
      justify-content: left;
      margin-left: 80px;
      flex-wrap: wrap;
      width: 100%;
      .appraisal {
        width: 609px;
        height: 170px;
        margin-right: 130px;
        margin-bottom: 40px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>